module.exports = __webpack_public_path__ + "img/sirius1.8f9e41a.png";